import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button, Modal, Checkbox, Upload, Table, Image, Form, Tag, Popover, Select, notification } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, FileImageOutlined } from '@ant-design/icons';
import { fetchData, sendData } from '../../../httpRequests';
import { useNavigate } from 'react-router-dom';
const { Search } = Input;



const form = {
    pharmacy_id: null,
    pharmacy_idFilter: 0,
    driver_id: null,
    driver_idFilter: 0
}


export default function Pharmacies() {
    const navigate = useNavigate();
    const [modalAsignar, setModalAsignar] = useState(false)
    const [idpharmacy, setIdPharmacy] = useState(Number(localStorage.getItem("PHARMACY_LOGGED")))
    const [driver, setDriver] = useState([])
    const [driverFilter, setDriverFilter] = useState([])
    const [pharmcies, setPharmcies] = useState([])
    const [pharmciesfilter, setPharmciesFilter] = useState([])
    const [pharmciesasigned, setPharmciesasigned] = useState([])
    const [pharmciesasignedFilter, setPharmciesasignedFilter] = useState([])

    const [formValues, setFormValues] = useState(form)

    const { pharmacy_id, driver_id, pharmacy_idFilter, driver_idFilter } = formValues


    useEffect(() => {
        getDrivers()
        getPharmacies()
        getPharmaciesAsign()
    }, [])

    const modalCreateAsinar = () => {
        setModalAsignar(true)

    }
    const handleCancel = () => {
        setModalAsignar(false)
    }
    const getDrivers = () => {
        const url = '/user/getDriverByPharmacy';
        sendData(url, { pharmacy_id: idpharmacy }).then((response) => {
            if (Object.keys(response).length > 0) {
                setDriver(response.driver)

                let dataDriver = [...response.driver]
                dataDriver.unshift({ driver_id: 0, id: 0, first_name: 'All' })
                setDriverFilter(dataDriver)

            }
        })
    }

    const getPharmacies = () => {
        const url = '/pharmacies/getPharmacies';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                setPharmcies(response.pharmacy)
                let dataPharmacies = [...response.pharmacy]
                dataPharmacies.unshift({ id_pharmacy: 0, id: 0, name: 'All' })
                setPharmciesFilter(dataPharmacies)
            }
        })
    }

    const getPharmaciesAsign = () => {
        const url = '/driver/assigned';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                setPharmciesasigned(response.driver)
                console.log(response.driver)
                setPharmciesasignedFilter(response.driver)
            }
        })
    }

    const handleFilterPhamacies = (e) => {
        setFormValues({
            ...formValues,
            pharmacy_id: e,

        })

    }
    const handleFilterDriver = (e) => {
        setFormValues({
            ...formValues,
            driver_id: e,

        })

    }

    const saveAsignar = async () => {
        const url = '/driver/asignar';
        sendData(url, { ...formValues }).then((response) => {
            if (response.ok) {
                getPharmaciesAsign()
                handleCancel()
                openNotificationWithIcon("success", response.msg)
            } else {
                console.log(response)
                openNotificationWithIcon("warning", response.msg)
            }
        })

    }

    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };

    const columns = [
        {
            title: 'PHARMACY IMG',
            render: ({ Pharmacy_img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={Pharmacy_img} />
                </div>
            )
        },
        {
            title: 'PHARMACY ',
            render: ({ pharmacy_name }) => (
                <div>
                    {pharmacy_name}
                </div>
            )
        },
        {
            title: 'DRIVER IMG',
            render: ({ driver_img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={driver_img} />
                </div>
            )
        },

        {
            title: 'DRIVER',
            render: ({ driver_id, driver_name }) => (
                <div style={{ cursor: 'pointer' }} onClick={() => navigate('/driverDetails/' + driver_id)}>
                    {driver_name}
                </div>
            )
        },
        {
            title: 'EMAIL',
            render: ({ driver_email }) => (
                <div>
                    {driver_email}
                </div>
            )
        },








    ]

    const onSearch = (value) => {
        let text = value.target.value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        if (text != '') {
            const filter = pharmciesasignedFilter.filter((e) => {
                return e.driver_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().includes(text) || e.pharmacy_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().includes(text)
            });
            setPharmciesasigned(filter)
        } else {
            setPharmciesasigned(pharmciesasignedFilter)
        }
    }

    const handleFilterPhamaciesSearch = (value) => {
        setFormValues({
            ...formValues,
            pharmacy_idFilter: value,
            driver_idFilter: 0

        })

        console.log(driver_idFilter)
        const filter = pharmciesasignedFilter.filter((e) => {
            console.log(e)
            return e.id_pharmacy == value
        })
        console.log(filter)



        if (value == 0) {
            setPharmciesasigned(pharmciesasignedFilter)
        } else {
            setPharmciesasigned(filter)
        }
    }

    const handleDriverSearch = (value) => {
        setFormValues({
            ...formValues,
            driver_idFilter: value,
            pharmacy_idFilter: 0

        })
        const filter = pharmciesasignedFilter.filter((e) => {

            return e.driver_id == value
        })

        if (value == 0) {

            setPharmciesasigned(pharmciesasignedFilter)
        } else {

            setPharmciesasigned(filter)
        }



    }

    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={6}>
                    <Search
                        size='large'
                        placeholder='Search name'
                        onChange={onSearch}
                    />
                </Col>
                <Col span={6}>
                    <Select
                        style={{ width: '100%' }}
                        size='large' name="pharmacy_idFilter"
                        placeholder='Select Pharmacy'

                        value={pharmacy_idFilter}
                        onChange={handleFilterPhamaciesSearch}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {pharmciesfilter.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={6} >

                    <Select
                        style={{ width: '100%' }}
                        size='large' name="driver_idFilter"
                        placeholder='Select Driver '
                        value={driver_idFilter}
                        onChange={handleDriverSearch}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {driverFilter.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.first_name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
                <Col span={6}>
                    <Button
                        onClick={modalCreateAsinar}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        <PlusOutlined />
                        Assign pharmacies to driver
                    </Button>
                </Col>
            </Row>
            <Modal
                title="Assign pharmacies to driver"
                visible={modalAsignar}
                onCancel={handleCancel}
                width={600}
                footer={null}
                closable={true}
            >
                <Row gutter={24}>
                    <Col span={24} className='formMarginInput' >
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Select Driver</label>
                        <Select
                            style={{ width: '100%' }}
                            size='large' name="pharmacy_id"
                            placeholder='Select Driver'
                            value={driver_id}
                            onChange={handleFilterDriver}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                            {driver.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.first_name}
                                </Select.Option>
                            ))
                            }
                        </Select>
                    </Col>

                    <Col span={24} style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <label htmlFor=""><span style={{ color: 'red', marginTop: '20px' }}>*</span>Select Pharmacy</label>
                        <Select
                            style={{ width: '100%' }}
                            size='large' name="pharmacy_id"
                            placeholder=' Select Pharmacy'

                            value={pharmacy_id}
                            onChange={handleFilterPhamacies}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                            {pharmcies.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.name}
                                </Select.Option>
                            ))
                            }
                        </Select>
                    </Col>

                    <Col span={24}>
                        <Button
                            onClick={saveAsignar}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: '10px' }}
                            disabled={pharmacy_id == null || driver_id == null}
                        >
                            <SaveOutlined />
                            Save
                        </Button>
                    </Col>
                    {/* <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Name</label>
                        <Input
                            type='text'
                            size='large'
                            name="name"


                        />
                    </Col> */}
                </Row>

            </Modal>
            <Table columns={columns} dataSource={pharmciesasigned} rowKey={(item) => item.id}
            />
        </div>
    )
}